<template>
  <div class="main_container">
    <emission-source />
<!--    <left-part :modelType="modelType" v-if="!isSetting && refreshTag && customerId == 38"></left-part>-->
    <right-part :modelType="modelType" v-if="!isSetting && refreshTag"></right-part>
    <setting style="z-index: 2" :modelType="modelType" v-if="isSetting"></setting>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import emissionSource from "@/modules/EmissionSource/emissionSource.vue";
import rightPart from "@/modules/DIYcomponents/rightPart.vue";
import leftPart from "@/modules/DIYcomponents/leftPart.vue";
import setting from "@/modules/DIYcomponents/setting.vue";

import { ref, shallowRef, computed, provide } from "vue";
import {
  Instantiate3DUIFunc,
  CloseBrowserFunc,
  OpenBrowserFunc,
  LoadPathFromJSFunc,
  StopPathFunc,
  CamFixFunc,
  CameraMove,
  IsShowBuildingsFunc,
  RoadHeatLineFunc,
  ShowHeatLineFunc,
  HideHeatLineFunc,
  CamLeapFunc,
  CamLeapFunc_,
  LoadWallFromJSFunc,
  ShowWallDataFunc,
  DrawBZLineFunc,
  DestroyLRFunc,
  CloseWallFunc,
} from "@/assets/js/unity3D/index.js";
export default {
  components: { emissionSource, rightPart, setting ,leftPart},
  props: {},
  data() {
    return {
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: "EmissionSourceMod",
      styleType: "",
      styleTypeMap: styleTypeMap,
      // curBG: "",
      refreshTag: true,
      eventData: {},
      countStart: 0,
      countTimer: 0,
      curMapType: "",
    };
  },
  computed: {},
  //监控data中的数据变化
  watch: {
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    flyTo() {
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        const earth = window.g_bme3dManager.earth;
        let view =
          mapViews[`mapViews_${this.customerId}`] &&
          mapViews[`mapViews_${this.customerId}`].dutyMod;
        if (view && view.length) {
          earth.camera.flyTo(view[0], view[1], view[2], view[3]);
        } else {
          g_bme3dManager.flyAround();
        }
      }
    },
    isBme3dManagerLoaded() {
      if (bmeConfig.mapType !== "3D") return;
      if (window.g_bme3dManager && window.g_bme3dManager.earth) {
        this.bme3dManagerLoaded = true;
        this.flyTo();
      } else {
        let that = this;
        if (that.loadedTimer) {
          clearTimeout(that.loadedTimer);
        }
        that.loadedTimer = setTimeout(function () {
          that.isBme3dManagerLoaded();
        }, 100);
      }
    },
    updateEventData(item) {
      this.eventData = item;
    },
    reset() {
      this.modelType = "EmissionSourceMod";
      this.refreshTag = true;
      this.eventData = {};
    },
    reload() {
      let that = this;
      this.refreshTag = false;
      this.$nextTick(() => {
        this.reset();
      });
    },
    stopEnough() {
      return;
      let that = this;
      let curTime = new Date().getTime();
      let delta = Math.floor((curTime - this.$countStart.timeStemp) / 1000);
      this.updateCountNum(delta);
      // document.title = delta;
      if (delta > bmeConfig.countTime) {
        //this.$router.push({ path: "/DutyMod" });
      } else {
        if (this.countTimer) {
          clearTimeout(this.countTimer);
        }
        this.countTimer = setTimeout(function () {
          that.stopEnough();
        }, 1000);
      }
    },
    // 阻止同时控制组件和3D场景
    stopControl() {
      console.log(bmeConfig);
      // console.log(e,CamFixFunc)
      // if(e) {
      //   CamFixFunc()
      // }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let that = this;
    this.styleType = bmeConfig.styleType;
    if (this.$route.query && this.$route.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    this.curMapType = this.$store.state.mapType;

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      CamLeapFunc();
    }, 500);
    this.$countStart.timeStemp = new Date().getTime();
    this.stopEnough();
  },
  unmounted() {},
  beforeRouteLeave(to, from, next) {
    if (CloseWallFunc) {
      CloseWallFunc();
    }
    setTimeout(() => {
      let clickShowWallJson = [
        {
          WallID: "20220105",
        },
        {
          WallID: "20220513",
        },
      ];
      ShowWallDataFunc(clickShowWallJson);
    }, 500);
    if (next) {
      next();
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    //console.log(2222);
    this.reload();
  },
};
</script>
<style scoped>
.main_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}
</style>
